/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_RequiredInputs */

const vi_warehouse_position_required = /** @type {(inputs: Warehouse_Position_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt buộc chọn vị trí`)
};

/**

* @param {Warehouse_Position_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_required = /** @type {((inputs?: Warehouse_Position_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_required(inputs)
});